import { render, staticRenderFns } from "./FeaturesUpdateModal.vue?vue&type=template&id=2c924dae&scoped=true"
import script from "./FeaturesUpdateModal.vue?vue&type=script&lang=js"
export * from "./FeaturesUpdateModal.vue?vue&type=script&lang=js"
import style0 from "./FeaturesUpdateModal.vue?vue&type=style&index=0&id=2c924dae&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c924dae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/al-khaleej/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c924dae')) {
      api.createRecord('2c924dae', component.options)
    } else {
      api.reload('2c924dae', component.options)
    }
    module.hot.accept("./FeaturesUpdateModal.vue?vue&type=template&id=2c924dae&scoped=true", function () {
      api.rerender('2c924dae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/common/FeaturesUpdateModal.vue"
export default component.exports